import React from 'react';
import { Field } from 'redux-form';

import Fields from 'components/Fields';
import { useFormatMessage } from 'components/IntlProvider';

interface CategoryType {
  id: number;
  category: string;
}

interface CategoryProps {
  categories: CategoryType[];
}

const Category = ({ categories }: CategoryProps) => {
  const t = useFormatMessage();
  return (
    <Field
      displayEmpty
      fullWidth
      component={Fields.Select}
      options={categories}
      helperText={t('fields.wizard.category.label', 'Pick a Product Group')}
      label={t('fields.wizard.category.helpertext', 'Product Group')}
      name="category"
    />
  );
};

export default Category;
